import React, { useState, useEffect  } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

import { login } from "../slices/auth";
import PasswordField from "./PasswordField";

const Login = () => {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [message, setMessage] = useState("");


  const dispatch = useDispatch();

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const msgCode = urlSearchParams.get("code")
    if (msgCode === "401") {
      setMessage("Invalid username or password");
    }
  }, []);
  const initialValues = {
    username: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("This field is required!"),
    password: Yup.string().required("This field is required!"),
  });

  const handleLogin = (formValue) => {
    const { username, password } = formValue;
    setLoading(true);

    dispatch(login({ username, password }))
      .unwrap()
      .then(() => {
        navigate("/home");
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  if (isLoggedIn) {
    return <Navigate to="/home" />;
  }

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={5}>
          <Card className="border-0 shadow-lg" style={{ borderRadius: '24px' }}>
            <div 
              style={{ 
                height: '120px', 
                background: 'var(--primary-gradient)', 
                borderTopLeftRadius: '24px', 
                borderTopRightRadius: '24px' 
              }}
            ></div>
            
            <Card.Body className="px-4 pb-5 pt-0">
              <div 
                className="mx-auto rounded-circle d-flex align-items-center justify-content-center bg-white shadow-sm"
                style={{
                  width: '80px',
                  height: '80px',
                  marginTop: '-40px',
                  marginBottom: '20px',
                  border: '4px solid white',
                  fontSize: '2rem',
                  color: '#4f46e5'
                }}
              >
                <i className="bi bi-person-circle"></i>
              </div>

              <h3 className="fw-bold text-center mb-4" style={{ color: 'var(--text-main)' }}>
                Welcome Back
              </h3>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleLogin}
              >
                <Form>
                  <div className="d-flex flex-column gap-3">
                    <div>
                      <label htmlFor="username" className="text-muted small fw-bold mb-1">Username</label>
                      <Field 
                        name="username" 
                        type="text" 
                        className="form-control form-control-lg bg-light border-0" 
                        style={{ fontSize: '1rem' }}
                      />
                      <ErrorMessage
                        name="username"
                        component="div"
                        className="text-danger small mt-1 fw-medium"
                      />
                    </div>

                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <label htmlFor="password" className="text-muted small fw-bold mb-0">Password</label>
                        <Link to="/forgetPassword" className="small text-decoration-none" style={{ color: '#4f46e5', fontWeight: '600' }}>
                          Forgot Password?
                        </Link>
                      </div>
                      <PasswordField name="password" />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-danger small mt-1 fw-medium"
                      />
                    </div>

                    <Button 
                      type="submit" 
                      className="btn-premium w-100 rounded-pill py-2 mt-3" 
                      disabled={loading}
                    >
                      {loading ? (
                        <span className="spinner-border spinner-border-sm me-2"></span>
                      ) : (
                        <i className="bi bi-box-arrow-in-right me-2"></i>
                      )}
                      Login
                    </Button>
                  </div>
                </Form>
              </Formik>

              {message && (
                <div className="mt-4">
                  <div className="alert alert-danger rounded-4 border-0 shadow-sm" role="alert">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    {message}
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
